import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	documentTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adminDocumentTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterResultsAnnouncement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	documentTitleGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adminDocumentTitleGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterResultsAnnouncementGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	documentTitle: {
		id: 'projects-directory-v3.page-layout.document-title',
		defaultMessage: 'Projects',
		description: 'Title for Projects Directory page that is shown in browser tab',
	},
	adminDocumentTitle: {
		id: 'projects-directory-v3.page-layout.admin-document-title',
		defaultMessage: 'Manage Projects',
		description: 'Title for Admin Projects Directory page that is shown in browser tab',
	},
	filterResultsAnnouncement: {
		id: 'projects-directory-v3.page-layout.filter-results-announcement',
		defaultMessage:
			'{itemCount, plural, =0 {No projects were found that match your search} one {{itemCount} project found} other {{itemCount} projects found}}',
		description:
			'Message for screen reader users to announce how many projects were found after filtering',
	},
	documentTitleGalaxia: {
		id: 'projects-directory-v3.page-layout.document-title-galaxia',
		defaultMessage: 'Spaces',
		description: 'Title for Projects Directory page that is shown in browser tab',
	},
	adminDocumentTitleGalaxia: {
		id: 'projects-directory-v3.page-layout.admin-document-title-galaxia',
		defaultMessage: 'Manage Spaces',
		description: 'Title for Admin Projects Directory page that is shown in browser tab',
	},
	filterResultsAnnouncementGalaxia: {
		id: 'projects-directory-v3.page-layout.filter-results-announcement-galaxia',
		defaultMessage:
			'{itemCount, plural, =0 {No spaces were found that match your search} one {{itemCount} space found} other {{itemCount} spaces found}}',
		description:
			'Message for screen reader users to announce how many projects were found after filtering',
	},
});
export default messages;
